import { ImageUrlRequest } from '@/types/imageSizing'

export function buildImageUrl({
  imageSrc,
  size,
  cropSize,
  focalPoint,
  crop,
}: ImageUrlRequest) {
  const params = new URLSearchParams({ rmode: crop ? 'crop' : 'max' })
  let { width, height } = size

  if (crop && cropSize) {
    if (cropSize.coordinates) {
      // Coordinate based crop
      const coords = cropSize.coordinates
      params.append(
        'cc',
        `${coords.left},${coords.top},${coords.right},${coords.bottom}`,
      )

      // Compensate for any side trim as the crop happens *after* the resize
      const totalSideTrim = coords.left + coords.right
      width = width / (1 - totalSideTrim)
    } else if (focalPoint) {
      // Focal point crop
      params.append('rxy', `${focalPoint.x},${focalPoint.y}`)
      params.append('height', height.toFixed(0))
    } else {
      // Center crop
      params.append('ranchor', 'center')
      params.append('height', height.toFixed(0))
    }
  }

  params.append('width', width.toFixed(0))

  params.append('format', 'webp')

  return `${imageSrc}?${params.toString()}`
}
